import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { HoverAnimation, Image, Square, KeepProportions, FrameBone, ParagraphBone } from '@gik/ui';

export interface ISamplePageTileProps extends Omit<React.HTMLAttributes<HTMLUListElement>, 'title'> {
  title?: string;
  imageUrl?: string;
  variant?: string;
  skeleton?: boolean;
}

const skelBem = bemBlock(`article-tile-skeleton`);
const Skeleton = (): React.ReactElement => (
  <div className={`${skelBem()}`}>
    <KeepProportions proportion={1}>
      <div className={skelBem('image-wrapper')}>
        <FrameBone className={skelBem('image')} />
      </div>
    </KeepProportions>
    <main>
      <ParagraphBone words={2} className={skelBem('category')} />
    </main>
  </div>
);

export default function SamplePageTile({
  className,
  title,
  variant,
  imageUrl,
  skeleton,
}: ISamplePageTileProps): React.ReactElement {
  const bem = bemBlock('sample-page-tile');

  if (skeleton) return <Skeleton />;

  return (
    <div className={bem(null, [{ [variant]: variant }], className)}>
      <HoverAnimation>
        <Image src={imageUrl} asBackground proportion={Square} className={bem('image')} />
      </HoverAnimation>
      <span className={bem('title')}>{title}</span>
    </div>
  );
}
